<template>

</template>

<script>
export default {
  name: "ConsoleBrand",
  mounted() {
    console.log('Los queremos mucho 😘')
    this.ConsoleBrand()
    console.log('saulo is ok but not running')
  },
  methods: {
    ConsoleBrand() {
      let normalStyle = [
        'color: #444',
        'font-family: helvetica, arial',
        'display:inline-block',
        'padding-top: 50px',
      ];
    
      let styleArray = [
        'width : 70px',
        'height : 70px',
        'color: #444',
        'font-size: 3em',
        'line-height: 3.15',
        'font-family: helvetica, arial',
      ];
      console.log('%cby %cZedPlan%c.com', normalStyle.join(';'), styleArray.join(';'), normalStyle.join(';'));
    },
  }
}
</script>

<style scoped>

</style>